// export const UserRoleEnum = Object.freeze({
//     ADMIN:'ADMIN',
//     EDITOR:'EDITOR',
//     VIEWER:'VIEWER'
// });

export enum UserRoleEnum {
    SUPER_ADMIN = 'SUPER_ADMIN',
    ADMIN = 'ADMIN',
    EDITOR = 'EDITOR',
    VIEWER = 'VIEWER',
}
